class WishlistButton extends HTMLElement {
    static creatingWishlistPromise = null;
    constructor() {
        super();
    }

    connectedCallback() {
        if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
        }
        if (!window.customerWishlist) {
            window.customerWishlist = {
                defaultList: null,
            };
        }

        window.SwymCallbacks.push((swat) => this.onSwymLoad(swat));

        this.defaultList = window.customerWishlist.defaultList;
        this.product = {
            epi: this.dataset.variantId,
            empi: this.dataset.productId,
            du: this.dataset.productUrl,
        };
        this.isWishlisted = false;

        this.updateEvent = new CustomEvent('customerWishlist:updated', {
            detail: {
                empi: this.product.empi,
                triggerBy: this,
            },
        });

        this.productImage = this.dataset.productImg;
        this.productTitle = this.dataset.productTitle;
        this.onAddSuccessMessage = this.dataset.wishlistedSuccess;
        this.onRemoveSuccessMessage = this.dataset.unwishlistedSuccess;
        this.shouldRemoveFromCart = this.dataset.removeFromCart !== undefined ? true : false;

        this.addEventListener('click', this.toggleWishlistedItem.bind(this));
        window.addEventListener('customerWishlist:updated', this.isInWishlist.bind(this));
    }

    async onSwymLoad(swat) {
        this.swat = swat;
        if (!this.defaultList) await this.setdefaultList();
        else this.isInWishlist();
    }

    async setdefaultList(cb = null) {
        this.swat.fetchLists({
            callbackFn: async (lists) => {
                for (let wishlist of lists) {
                    if (wishlist.lname === 'My Wishlist') {
                        this.defaultList = wishlist;
                        window.customerWishlist.defaultList = wishlist;
                        break;
                    }
                }

                if (!this.defaultList) await this.ensureWishlistCreated();

                this.isInWishlist();
                if (cb) cb();
            },
            errorFn: () => {
                console.error('Error while fetching wishlists');
            },
        });
    }

    async ensureWishlistCreated() {
        if (!WishlistButton.creatingWishlistPromise) {
            WishlistButton.creatingWishlistPromise = this.createWishlist();
        }
        try {
            await WishlistButton.creatingWishlistPromise;
        } finally {
            WishlistButton.creatingWishlistPromise = null;
        }
    }

    async createWishlist() {
        const isCreatingWishlist = window.sessionStorage.getItem('creating_wishlist') === '1' ? true : false;
        if (isCreatingWishlist) return;

        window.sessionStorage.setItem('creating_wishlist', '1');
        let listConfig = {
            lname: 'My Wishlist',
        };
        try {
            const newList = await new Promise((resolve, reject) => {
                this.swat.createList(
                    listConfig,
                    (newList) => {
                        resolve(newList);
                    },
                    (error) => {
                        reject(error);
                    },
                );
            });
            this.defaultList = newList;
            window.sessionStorage.setItem('creating_wishlist', '0');
            window.customerWishlist.defaultList = newList;
            console.info('Successfully created a new List', newList);
        } catch (error) {
            window.sessionStorage.setItem('creating_wishlist', '0');
            console.error('Error while creating a List', error);
        }
        // let onSuccess = function (newList) {
        //     this.defaultList = newList;
        //     window.sessionStorage.setItem('creating_wishlist', '0');
        //     window.customerWishlist.defaultList = newList;
        //     console.info('Successfully created a new List', newList);

        // };
        // let onError = function (error) {
        //     console.error('Error while creating a List', error);
        // };
        // this.swat.createList(listConfig, onSuccess, onError);
    }

    // When there are multiple wishlist-button on the same page, we
    // update the state for the one that is not been clicked
    // We keep the others wishlist-button not sync, because is not worth it
    // Update all the button if no action on that product is been done
    isInWishlist(event = null) {
        if (event && event?.detail.empi == this.product.empi && this !== event?.detail.triggerBy)
            this.defaultList = window.customerWishlist.defaultList;

        if (event && event?.detail.empi == this.product.empi && this === event?.detail.triggerBy) return;

        this.defaultWishlistExist();
        this.isWishlisted = this.defaultList?.listcontents?.some((item) => item.epi == this.product?.epi);
        this.setIcon();
    }

    toggleWishlistedItem(event) {
        event.stopImmediatePropagation();
        const preLoadImages = new Image();
        preLoadImages.src = this.productImage;
        if (!this.defaultList) this.defaultList = window.customerWishlist.defaultList;

        if (this.isWishlisted) this.removeFromWishlist();
        else {
            let cb = null;
            if (this.shouldRemoveFromCart) {
                const cartItems = this.closest('.cart-item');
                if (cartItems) {
                    const removeButton = cartItems.querySelector('cart-remove-button');
                    if (removeButton) cb = removeButton.click.bind(removeButton);
                }
            }
            this.addToWishlist(cb);
        }
    }

    addToWishlist(cb = null) {
        this.swat.addToList(
            this.defaultList.lid,
            this.product,
            () => {
                this.popupSuccesNotification('add');
                this.isWishlisted = true;
                this.classList.add('disabled', 'swym-added', 'swym-adding');
                if (cb) cb();
                this.updateWishlist();
            },
            (error) => {
                console.error(`Error while Adding ${this.product}`, error);
            },
        );
    }

    removeFromWishlist() {
        this.swat.deleteFromList(
            this.defaultList.lid,
            this.product,
            () => {
                this.popupSuccesNotification('remove');
                this.isWishlisted = false;
                this.classList.remove('disabled', 'swym-added', 'swym-adding');
                this.updateWishlist();
            },
            (error) => {
                console.error(`Error while removing ${this.product}`, error);
            },
        );
    }

    updateWishlist() {
        this.setdefaultList(() => window.dispatchEvent(this.updateEvent));
    }

    defaultWishlistExist() {
        if (this.defaultList) {
            if (this.shouldRemoveFromCart) this.style.display = 'inline';
            else this.style.display = 'block';
        } else if (window.customerWishlist.defaultList) {
            this.defaultList = window.customerWishlist.defaultList;
            if (this.shouldRemoveFromCart) this.style.display = 'inline';
            else this.style.display = 'block';
        } else this.style.display = 'none';
    }

    setIcon() {
        if (this.isWishlisted) this.classList.add('disabled', 'swym-added', 'swym-adding');
        else this.classList.remove('disabled', 'swym-added', 'swym-adding');
    }

    popupSuccesNotification(action) {
        const { mainContainer } = this.swat.ui.uiRef;
        const { NotificationPosition, NotificationDuration } = this.swat.ui.uiRef.settings.UI;
        const container = mainContainer.querySelector('.swym-wishlist-notifications-container');
        const animationContainer = document.createElement('div');
        animationContainer.classList.add(
            'swym-notifications-container',
            `swym${NotificationPosition.charAt(0).toUpperCase() + NotificationPosition.slice(1)}`,
        );

        animationContainer.innerHTML = `
            <div class="swym-notification-wishlist swym-clickable" tabindex="0" role="button">
                <div class="swym-product-tile">
                    <img class="swym-image" src="${this.productImage}" alt="${this.productTitle}" title="${this.productTitle}">
                    <div class="swym-details-container">
                        <div class="swym-details" role="alert">
                            <span class="swym-emphasis">
                                ${this.productTitle}
                            </span>
                            ${action === 'add' ? this.onAddSuccessMessage : this.onRemoveSuccessMessage}
                        </div>
                    </div>
                </div>
            </div>
            `;

        container.appendChild(animationContainer);
        animationContainer.classList.add('swym-showing');

        setTimeout(() => {
            animationContainer.classList.remove('swym-showing');
            setTimeout(() => {
                animationContainer.remove();
            }, 300);
        }, NotificationDuration);
    }
}

customElements.define('wishlist-button', WishlistButton);
